
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.518 2h8.93a3 3 0 012.796 1.913l1.788 4.597A2.356 2.356 0 0121 11.412V19a3 3 0 01-3 3H6a3 3 0 01-3-3v-7.588A2.356 2.356 0 011.968 8.51l1.788-4.597A3 3 0 016.552 2h1.966zm9.33 7.19c.016.006.031.014.046.021l.702.35c.41.206.882.258 1.327.147a.355.355 0 00.245-.473L18.38 4.638A1 1 0 0017.448 4h-.711l1.112 5.19zM14.693 4l1.138 5.314-.216.086a3 3 0 01-2.228 0L13 9.246V4h1.691zM9.307 4H11v5.246l-.386.154a3 3 0 01-2.228 0l-.216-.086L9.308 4zM7.263 4L6.151 9.19l-.045.021-.702.35c-.41.206-.882.258-1.327.147a.355.355 0 01-.245-.473L5.62 4.638A1 1 0 016.552 4h.711zM11 14a2 2 0 00-2 2v3.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V16a2 2 0 00-2-2h-2z"}})])
          )
        }
      }
    